import { TestimonialsPage } from '../../page-components/home/home-components/TestimonialsPage';

export default TestimonialsPage;
